import { notify } from "shared/ui/Notifications/notify"

/**
 * Handles sequence errors by checking the response, which can be an empty string, a non-empty string, or an object, for an error message.
 * If an error is found, it displays a notification with the provided error message.
 *
 * @function handleSequenceError
 * @param res - The response from an API call, which can be any type.
 * @param defaultTitle - The default title for the error notification.
 * @returns Returns false if an error is found and handled, otherwise true.
 */
const handleSequenceError = (
  res: unknown,
  defaultTitle: string = "Error"
): boolean => {
  // If res is an object with an "Err msg" key
  if (typeof res === "object" && res !== null) {
    // Type guard to check if the object has "Err msg" property
    if ("Err msg" in res) {
      const errorMsg = (res as Record<string, unknown>)["Err msg"]
      notify.error(
        defaultTitle,
        typeof errorMsg === "string" ? errorMsg : String(errorMsg)
      )
      return false
    }
    return true // No error message found in the object
  }

  // If res is an empty string, assume there's an error
  if (typeof res === "string" && res.trim() === "") {
    notify.error(defaultTitle, "An unknown error occurred.")
    return false
  }

  // In case res is neither an object nor a string (shouldn't normally happen)
  return true
}

export default handleSequenceError
